import React from 'react';
import { Table, TableProps } from 'antd';

interface DataTableProps<RecordType> extends TableProps<RecordType> {
  bordered?: boolean;
  expandedRowRender?: (record: RecordType, index: number, indent: number, expanded: boolean) => React.ReactNode;
  loading?: boolean;
  columns?: TableProps<RecordType>['columns'];
  dataSource: TableProps<RecordType>['dataSource'];
  handleTableChange?: TableProps<RecordType>['onChange'];
  rowKey?: string | ((record: RecordType) => string);
  rowExpandable?: (record: RecordType) => boolean; 
  expandIcon?: (props: { expanded: boolean }) => React.ReactNode; 
}

const DataTable = <RecordType extends object>({
  bordered = false,
  expandedRowRender,
  loading = false,
  columns,
  dataSource,
  handleTableChange,
  rowKey,
  rowExpandable, 
}: DataTableProps<RecordType>) => {
  return (
    <Table<RecordType>
      expandable={{
        expandedRowRender,
        rowExpandable, 
        expandIcon: undefined, 
      }}
      bordered={bordered}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={loading}
      onChange={handleTableChange}
      className="rounded-lg overflow-hidden"
      rowKey={rowKey}
    />
  );
};

export default DataTable;
